module.exports = __webpack_public_path__ + "img/background_principal_mov.b21285a4.webp";